module.exports = __webpack_public_path__ + "static/media/brev.6ab05095.mp3";